var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-gray-100 py-6",
      staticStyle: { height: "calc(100vh - 70px)" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "bg-white overflow-hidden shadow rounded-lg max-w-4xl mx-auto"
        },
        [
          _c(
            "div",
            {
              staticClass: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
                },
                [
                  _vm._m(0),
                  _c("div", { staticClass: "ml-4 mt-2 flex-shrink-0" }, [
                    _c(
                      "span",
                      { staticClass: "inline-flex rounded-md shadow-sm" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-4 disabled:opacity-75",
                            attrs: {
                              type: "button",
                              disabled: _vm.buttonLoaders.isResyncingStatus
                            },
                            on: { click: _vm.resyncStatus }
                          },
                          [
                            _vm._v(" Resync"),
                            _vm.buttonLoaders.isResyncingStatus
                              ? _c("span", [_vm._v("ing")])
                              : _vm._e(),
                            _vm._v(" Status ")
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.createNew("Abandoned")
                              }
                            }
                          },
                          [_vm._v(" Create new ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          ),
          _c("div", [
            _c(
              "ul",
              [
                _vm._l(_vm.templates, function(template, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out",
                        attrs: { href: "#" }
                      },
                      [
                        _c("div", { staticClass: "px-4 py-4 sm:px-6" }, [
                          _c("div", { staticClass: "grid grid-cols-7" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-sm leading-5 font-medium text-indigo-600 truncate col-span-2"
                              },
                              [_vm._v(" " + _vm._s(template.name) + " ")]
                            ),
                            _c("div", { staticClass: "col-span-2" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ",
                                  class: {
                                    "bg-yellow-100 text-yellow-800":
                                      template.status === "rejected",
                                    "bg-green-100 text-green-800":
                                      template.status === "approved"
                                  }
                                },
                                [_vm._v(" " + _vm._s(template.status) + " ")]
                              ),
                              template.status === "rejected"
                                ? _c(
                                    "span",
                                    { staticClass: "text-xs text-gray-700" },
                                    [
                                      _c("p", [
                                        _vm._v("Reason for rejection:")
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(template.reasonForRejection) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-span-3 text-gray-700 text-sm whitespace-pre-wrap"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getTemplateMessage(template)) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                }),
                _vm.templates.length === 0
                  ? _c(
                      "li",
                      { staticClass: "text-center text-gray-700 text-sm p-20" },
                      [
                        _vm._v(
                          " Create a template to start sending marketing messages "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      ),
      _vm.showModal
        ? _c("CreateTemplate", {
            on: { close: _vm.closeModal, create: _vm.onCreate }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-4 mt-2" }, [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Marketing templates ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }